/* eslint-disable import/no-cycle */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, Divider, Stack } from '@chakra-ui/core';
import { DropTarget, FormFieldT } from './types';
import { DroppableZone } from './DroppableZone';
import { FormSection } from './FormSection';
import { FormField } from './FormField';
import { isSectionSchema } from './utils';

interface FormFollowupProps {
  followUps: FormFieldT['followUpQuestionList'];
  fieldId: string;
  path: number[];
  parentIsAdvanced?: boolean;
  handleDropInFollowUp: (dropTarget: DropTarget, optionId?: string) => void;
  optionId: string;
  index: number;
}

export function FormFollowup({
  path,
  followUps,
  parentIsAdvanced,
  handleDropInFollowUp,
  optionId,
  fieldId,
  index,
}: FormFollowupProps): JSX.Element {
  const relevantItemsForThisOption = followUps?.filter((item) => item.optionId === optionId) || [];

  return (
    <Box style={{ marginTop: '10px' }}>
      <DroppableZone
        path={[...path, index, 0]}
        parentId={fieldId}
        onDropItem={(dropTarget) => handleDropInFollowUp(dropTarget, optionId)}
        isAdvancedSectionTarget={parentIsAdvanced}
        hideDropZoneMessage={relevantItemsForThisOption.length !== 0}
        disabled={parentIsAdvanced}
        className="followup-initial-dropzone"
      />

      <Stack divider={<Divider orientation="horizontal" />}>
        {relevantItemsForThisOption.map((item, indexWithinFilteredList) => {
          const originalIndex = followUps!.findIndex((originalItem) => originalItem?.id === item.id);
          const currentIndex = originalIndex >= 0 ? originalIndex : indexWithinFilteredList;
          const itemPath = [...path, index];
          return (
            <React.Fragment key={item.id || indexWithinFilteredList}>
              {isSectionSchema(item) ? (
                <FormSection
                  section={item}
                  path={[...itemPath, currentIndex]}
                  onDropItem={(dropTarget) => handleDropInFollowUp(dropTarget, optionId)}
                  parentIsAdvanced={parentIsAdvanced}
                  optionId={optionId}
                  followupPath={path}
                />
              ) : (
                <FormField
                  field={item}
                  path={[...itemPath, currentIndex]}
                  onDropItem={(dropTarget) => handleDropInFollowUp(dropTarget, optionId)}
                  parentIsAdvanced={parentIsAdvanced}
                  optionId={optionId}
                  followupPath={path}
                />
              )}
              <DroppableZone
                path={[...itemPath, currentIndex + 1]}
                parentId={fieldId}
                onDropItem={(dropTarget) => handleDropInFollowUp(dropTarget, optionId)}
                isAdvancedSectionTarget={parentIsAdvanced}
                disabled={parentIsAdvanced}
              />
            </React.Fragment>
          );
        })}
      </Stack>
    </Box>
  );
}
